'use client';

import { emptyLabel } from "./Select.data.js";
const defaultProps = {
  emptyLabel,
  inputSpacing: "md"
};
export {
  defaultProps
};
